export const CONFIGURATION_TOASTS = {
  SAVED_CONFIGURATION_TOASTS: 'Configuration successfully saved',
};
